module.exports = __webpack_public_path__ + "img/slide7_vn.31be09da.jpg";